var map = {
	"./br/PT/S1/bg155.jpg": 1521,
	"./br/PT/bg155.jpg": 10843,
	"./in/EN/S1/bg155.jpg": 30792,
	"./ph/EN/S1/bg155.jpg": 28455,
	"./ph/EN/bg155.jpg": 77523,
	"./vn/VI/S1/bg155.jpg": 66739
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 58368;